import { render, staticRenderFns } from "./LastReports.vue?vue&type=template&id=b789b546"
import script from "./LastReports.vue?vue&type=script&lang=js"
export * from "./LastReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports